import { render, staticRenderFns } from "./goback.vue?vue&type=template&id=70204933&scoped=true&"
import script from "./goback.vue?vue&type=script&lang=js&"
export * from "./goback.vue?vue&type=script&lang=js&"
import style0 from "./goback.vue?vue&type=style&index=0&id=70204933&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70204933",
  null
  
)

export default component.exports